// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 143 ? "app" : chunkId) + "." + {"73":"aac63c55db7616116336","143":"a74c9fcc098cfae0f026"}[chunkId] + ".css";
};